import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { formValueSelector } from 'redux-form';
// import { Link } from 'react-router-dom';

import QuickPortForm from 'components/PortForm/quick';
import QuickSubNav from 'components/SubNav/quick';
import { quickSubmitPort, quickInternalPort } from 'actions/quickSubs';
import { getQuickPortResponse, getSubmitStatus } from 'reducers';
import { quickSubPage } from 'decorators/subPage';

let QuickNewPort = ({
  subId,
  sub,
  user,
  initialValues,
  submitPort,
  internalPort,
  portResponse,
  ...props
}) => {
  if (!sub || !user) {
    return <div>Loading</div>;
  }

  const handleSubmit = (values) => {
    let params;
    let portAction;
    if (values.old_carrier === 'other') {
      const { old_carrier, ...restValues } = values;
      params = restValues;
      portAction = submitPort;
    } else {
      params = { mdn: values.mdn };
      portAction = internalPort;
    }
    return portAction(subId, params).then(() =>
      toast.success('Port in requested'),
    );
  };

  return (
    <div>
      <h1>New Quick Port</h1>
      <QuickSubNav />
      <br />
      <QuickPortForm
        initialValues={initialValues}
        onSubmit={handleSubmit}
        {...props}
      />
    </div>
  );
};

const mapModelsToValues = (sub, { address }) => {
  const { address1, address2, city, state, zip_code } =
    address && address.length > 0 && address[0];

  return {
    old_carrier: '',
    mdn: '',
    carrier_account: '',
    carrier_password: '',
    address1,
    address2,
    city,
    state,
    zip_code,
  };
};

const mapStateToProps = (state, { subId, sub, user }) => {
  const selector = formValueSelector('port');
  return {
    portResponse: getQuickPortResponse(state, subId),
    saveStatus: getSubmitStatus(state, 'port'),
    initialValues: sub && user && mapModelsToValues(sub, user),
    oldCarrierValue: selector(state, 'old_carrier'),
    newPort: true,
    showEsim: sub?.vendor === 'tsp',
  };
};

const mapDispatchToProps = {
  submitPort: quickSubmitPort,
  internalPort: quickInternalPort,
};

QuickNewPort = compose(
  quickSubPage,
  connect(mapStateToProps, mapDispatchToProps),
)(QuickNewPort);

export default QuickNewPort;
